import "../../styles/global.scss";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useState } from "react";
import { serverUrl } from "../../helpers/utility";
import logo from "../../images/logo.png";

function ForgotPassword() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  async function onSubmit(data) {
    try {
      setError(null);
      await axios.post(`${serverUrl}/auth/forgot-password`, {
        email: data.emailAddress,
      });
      setSubmitted(true);
    } catch (err) {
      console.error(`ERR: forgot-password submit. ${err}`);
      setError("We couldn't start the reset right now. Please try again.");
    }
  }

  return (
    <Container fluid className={`no-padding no-margin container-fluid`}>
      <Row className="justify-content-center" style={{ paddingTop: 40 }}>
        <Col lg={5}>
          <Card>
            <Card.Body style={{ padding: 24 }}>
              <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
                <img src={logo} style={{ height: 32 }} />
              </div>
              <h3 className="h4 mb-2 text-center">Forgot password</h3>
              <p className="text-muted text-center">
                Enter your email and we'll send you a reset link.
              </p>
              {submitted ? (
                <div className="alert alert-success mt-3">
                  If the account exists, we've emailed a reset link.
                </div>
              ) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <label>Email address</label>
                  <input
                    {...register("emailAddress", { required: true })}
                    className="form-control"
                    type="email"
                    autoFocus
                    required
                  />
                  {errors.emailAddress ? (
                    <div className="text-danger mt-1">Email is required</div>
                  ) : null}

                  {error ? <div className="text-danger mt-3">{error}</div> : null}

                  <input
                    className="form-control btn btn-primary mt-3"
                    type="submit"
                    value={`SEND RESET LINK`}
                  />
                </form>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ForgotPassword;

